export default __webpack_public_path__ + "static/media/Look of the Day.2d99f966.png";